import { couple } from '@/mocks/wedding';

const PANEL_BG =
  'https://readdy.ai/api/search-image?query=Romantic%20close%20portrait%20of%20a%20bride%20and%20groom%20standing%20close%20together%20in%20warm%20golden%20light%2C%20soft%20dark%20blurred%20interior%20background%2C%20intimate%20cinematic%20wedding%20photography%2C%20muted%20warm%20brown%20tones&width=2400&height=1350&seq=wed-panel-couple&orientation=landscape';

export default function CouplePanel() {
  const people = [couple.groom, couple.bride];

  return (
    <section className="panel" data-side="left" id="couple">
      <img className="panel-bg" src={PANEL_BG} alt="따뜻한 빛 아래 마주 선 신랑과 신부" data-parallax="0.32" />
      <div className="panel-veil" aria-hidden="true" />
      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>
          02 — 신랑 · 신부
        </p>
        <h2 data-reveal>
          서로를 <em className="accent">닮아가는</em>
          <br />
          두 사람
        </h2>
        <p className="sub" data-reveal>
          2021년 겨울 우연히 마주 앉은 두 사람이, 이제 같은 계절을 함께 걷습니다. 서로의 가장 편안한
          사람이 되어 주기로 했습니다.
        </p>

        <div className="couple-grid">
          {people.map((p) => (
            <article className="card" key={p.name} data-reveal>
              <h3 className="card-title">
                <span className="role">{p.role === 'Groom' ? 'Groom · 신랑' : 'Bride · 신부'}</span>
                {p.name}
              </h3>
              <p className="card-meta">{p.parents}</p>
              <div className="card-actions">
                <a className="icon-btn" href={`tel:${p.phone}`}>
                  <i className="ri-phone-line" aria-hidden="true" />
                  전화
                </a>
                <a className="icon-btn" href={`sms:${p.phone}`}>
                  <i className="ri-message-3-line" aria-hidden="true" />
                  문자
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}